import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
`

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
`

export const Title = styled.p`
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #000000;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    display: flex;
    gap: 8px;
`

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`
